import utils from 'lib/utils';
import config from 'config';
import { resTransform } from './transforms';

const { baseUrl } = config;

export const fetchAllBiofuelCircles = async () => {
  try {
    const url = `${baseUrl}/BioFuelRegistration/api/ReferenceData/FetchAllBiofuelCircles`;
    const res = await utils.fetch(url).ready;
    const resData = await utils.processApiRes(res);
    return resTransform.fetchList(resData);
  } catch (err) {
    const errors = await utils.processApiErrors(err, '', 'FetchAllBiofuelCircles');
    throw errors;
  }
};
